/**
 * External Dependencies
 */
import 'jquery';

$(document).ready(() => {
  // nav opener
  $('.navbar-burger').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('.navbar-menu').toggleClass('is-active')
  });

  // dropdown opener
  $('.dropdown-opener').on('click', function(e) {
    e.preventDefault();
    $(this).next('.navbar-dropdown').toggleClass('is-active-dropdown');
    $(this).children('i').toggleClass('fa-chevron-down fa-chevron-up');
  });

  // video play button
  $('.video-play-button').on('click', function(e) {
    e.preventDefault();
    let videoId = $(this).data('id');
    if($(this).children('i').hasClass('fa-play')) {
      $(this).children('i').removeClass('fa-play').addClass('fa-pause');
      $('#video-' + videoId).trigger('play');
    }else {
      $(this).children('i').addClass('fa-play').removeClass('fa-pause');
      $('#video-' + videoId).trigger('pause');
    }
  })

  //button smooth scroll
  $('a.button').on('click', function(e) {
    var target = $(this).attr('href');
    if(target != undefined && target.charAt(0) === "#") {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $(target).offset().top - 60}, 2000);
    }
  })

  //open search
  $('.search-opener').on('click', function(e) {
    e.preventDefault();
    $('.header-search-input').toggleClass('is-visible');
  })

  // position select hanlder
  $('#position-tax').on('change', function() {
    let slug = $(this).val();
    let postsPerPage = $('.position-tax-selectors-container').data('posts');

    let data = {
      'action': 'filter_positions',
      'val' : slug,
      'posts_per_page' : postsPerPage,
      'query': window.ahooy_filter_positions.posts,
    };

    filterPositions(data);
  })
});

/**
 *
 * @param object data
 * @param string el
 */
function filterPositions(data) {
  $.ajax({ // you can also use $.post here
    method: 'POST',
    url: window.ahooy_filter_positions.ajaxurl, // AJAX handler
    data: data,
    dataType: 'json',

    beforeSend: function () {
      $('.single-open-position-component').remove();
    },

    success: function (response) {
      if (response.count >= 1) {
        $('.open-positions-response-cols').append(response.content);
      }
      else {
        $('.empty-response').removeClass('is-hidden');
      }
    },
  });
}

